import React from 'react';
import { useSelector } from 'react-redux';
import TooltipWrapper from 'components/DesignSystem/TooltipWrapper';
import Icon from 'components/DesignSystem/Icon';
import { Chart } from 'helper/products/synopticCharts';
import { selectChart } from 'redux/reducers/synopticChartsReducer';

import './index.scss';

export default function HelpIcon() {
  const chart: Chart | undefined = useSelector(selectChart);
  const tooltipText = chart ? chart.descricao : 'Selecione um campo para ver sua descrição.';

  return (
    <div className="h-100 d-flex align-items-center">
      <div className="synoptic-charts-tooltip-container position-relative">
        <TooltipWrapper title={tooltipText} placement="bottom">
          <Icon iconType="help" size="large" />
        </TooltipWrapper>
      </div>
    </div>
  );
}
